// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3elgC","modalFooterButton":"ModalNotes_modalFooterButton__eql8Z"};